import { BaseService } from '../common/service/base.service';

export class BaseBuyerService extends BaseService {
  constructor(apiVersion: string = 'v1') {
    super(process.env.REACT_APP_BUYER_API_URL || '', apiVersion);
  }
}

export class BaseBuyerServiceV3 extends BaseBuyerService {
  constructor() {
    super('v3');
  }
}
